// import axios from "axios";
// import Cookies from "js-cookie";

// const axiosClient = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL,
//   headers: {
//     Accept: "application/json",
//   },
// });

// axiosClient.interceptors.request.use(
//   async (config) => {
//     const token = Cookies.get("ots_website_security");
//     if (token) {
//       config.headers["Authorization"] = "Bearer " + token;
//     } else {
//       delete config.headers["Authorization"];
//     }
//     return config;
//   },
//   (err) => Promise.reject(err),
// );

// export default axiosClient;

import axios from "axios";
import Cookies from "js-cookie";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
    platform: process.env.REACT_APP_PLATFORM,
    appversion: process.env.REACT_APP_APP_VERSION,
  },
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = Cookies.get("ots_website_security");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosClient;
